import { useErrorHandlingQuery } from '@backoffice-frontend/data-fetching'
import { useAdVehicleStreamUpcomingWaypointsQuery } from './useUpcomingWaypoints.hook'

export const useUpcomingWaypoints = ({ vehicleId }: { vehicleId: string }) => {
  const { data } = useErrorHandlingQuery(
    useAdVehicleStreamUpcomingWaypointsQuery,
    {
      variables: {
        vehicleId,
      },
      pollInterval: 3 * 1000,
    },
  )

  const upcomingWaypoints = data?.vehicle.upcomingWaypoints || []
  const upcomingWaypoint = upcomingWaypoints.at(0)

  const nextFutureWaypoints = upcomingWaypoints.slice(1)

  return {
    waypoint: upcomingWaypoint,
    futureWaypoints: nextFutureWaypoints,
  }
}
